import React, { useState, useEffect } from 'react';
import { useLinesContext } from '../../contexts/Lines';
import { makeStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import { useAuthContext } from '../../contexts/Auth';
import { getUserAttributes } from '../../utils';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import GlowingButton from '../BuildingBlocks/Button/GlowingButton';
import companyInfo from '../../themes/themes';

const useStyles = makeStyles((theme: any) => ({
  button: {
    position: 'fixed',
    zIndex: 10000,
    left: '70%',
    top: '85%',
    width: '300px',
  },
  video: {
    zIndex: 10000,
    height: '53vh',
    width: '100vh',
    position: 'fixed',
    left: '50%',
    transform: 'translate(-45%, -50%)',
    top: '50%',
    border: 'hidden',
    borderRadius: theme.spacing(1.5),
    boxShadow: `0px -16px 2000px 20px grey`,
  },
}));

export default function LineTutorialVideo() {
  const classes = useStyles();
  const [userAttributes, setUserAttributes] = useState({});
  const [showVideo, setShowVideo] = useState(true);
  const { trackEvent } = useEventTrackerContext();
  const { lines } = useLinesContext();
  const { user } = useAuthContext();
  const theme = process.env.REACT_APP_THEME;

  useEffect(() => {
    getUserAttributes().then((attr) => setUserAttributes(attr));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function setVideoToSeen() {
    try {
      setShowVideo(false);
      await Auth.updateUserAttributes(user, {
        'custom:qob_video_show': '0',
      });
      trackEvent({
        event: 'qob_see_line_lab_video',
      });
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <React.Fragment>
      {lines?.length === 0 &&
        showVideo &&
        userAttributes['custom:qob_video_show'] === '1' && (
          <>
            <iframe
              className={classes.video}
              id="ohad3"
              src="https://fast.wistia.net/embed/iframe/ev9d65s44f?videoFoam=true"
              title="8fig short Video"
              allow="autoplay; fullscreen"
              scrolling="no"
              name="8fig short Video"
            />
            <div className={classes.button}>
              <GlowingButton onClick={setVideoToSeen}>
                Do you already know how to use {companyInfo[theme].company}?
                Skip This Video
              </GlowingButton>
            </div>
          </>
        )}
    </React.Fragment>
  );
}
